import { Skeleton, Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import useGetCollection from "../hooks/getCollection";
import ScreenBase from "./ScreenBase";
import Affiliate from "../models/affiliate";
import AffiliateTile from "../components/affiliateTile";
import ScreenBanner from "../components/screenBanner";
import gammaWaves from "../assets/gammaWaves.jpg";

const AffiliateScreen: FC = () => {
	const { data: affiliateData, loading } = useGetCollection<Affiliate[]>('/affiliate/all?isPublished=true');

	const [affiliates, setAffiliates] = useState<Affiliate[]>([]);

	useEffect(() => {
		setAffiliates(affiliateData || []);
	}, [affiliateData]);

	return (
		<ScreenBase
			fixedChildren={(
				<Stack spacing={2}>
					<ScreenBanner
						title="Affiliates"
						bannerImage={gammaWaves}
						height={120}
						verticalAdjust="60%"
						brightnessAdjust={0.75}
					/>
				</Stack>
			)}
			scrollableChildren={(
				<Stack spacing={4} minHeight="calc(100vh - 525px)">
					<Stack spacing={2} px={4} maxWidth="70ch"> 
						<Typography variant="body2" color="textPrimary">
							This page features the software, gear, and services I personally use and trust.
							Purchasing through these affiliate links supports my work at no extra cost to you.
							I only recommend tools I believe in, so you can be confident in their quality—thanks
							for your support!
						</Typography>
					</Stack>
					<Stack direction="row" sx={{ flexWrap: 'wrap', gap: '30px 41px' }}>
						{!loading && (
							<>
								{affiliates.map((affiliate, index) => (
									<AffiliateTile key={`affiliate-${index}`} affiliate={affiliate} />
								))}
							</>
						)}
						{loading && (
							<>
								{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
									<Skeleton key={`skel-${i}`} variant="rounded" width={350} height={431} />
								))}
							</>
						)}
					</Stack>
				</Stack>
			)}
		/>
	)
};

export default AffiliateScreen;
